import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=20c1e1fa&scoped=true&"
import script from "./Platform.vue?vue&type=script&lang=js&"
export * from "./Platform.vue?vue&type=script&lang=js&"
import style0 from "./Platform.vue?vue&type=style&index=0&id=20c1e1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1e1fa",
  null
  
)

component.options.__file = "Platform.vue"
export default component.exports